module.exports = __webpack_public_path__ + "img/country-3.8960bafe.png";